<script setup>
import {defineEmits, defineExpose, defineProps, onMounted, ref} from 'vue'

// Props & emits
const emit = defineEmits(['changed'])

const props = defineProps({
  activeRequestFields: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const defaultFormData = {
  service_url: '',
  app_url: '',
  preland_url: '',
  test_login: '',
  test_password: '',
  plan_to_spend: '',
}

let formData = ref(cloneSafe(defaultFormData))

// Methods
onMounted(() => {
  init()
})

const init = () => {
  if (props.activeRequestFields) {
    formData.value = Object.assign(formData.value, props.activeRequestFields)
  }
}

const resetForm = () => {
  formData.value = cloneSafe(defaultFormData)
}
const onChange = () => {
  emit('changed', {fields: formData.value})
}

defineExpose({resetForm})
</script>

<template>
  <div class="form-group">
    <label for="dating-wl-ad-account-link">Link to the Dating Service *</label>
    <div class="input-group">
      <input
        v-model="formData.service_url"
        @change="onChange"
        :disabled="disabled"
        class="form-control"
        id="dating-wl-ad-account-link"
        required
        type="url"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="dating-wl-ad-account-app-link">Do You Have an App? (If Yes, Please Provide a Link)</label>
    <div class="input-group">
      <input
        v-model="formData.app_url"
        @change="onChange"
        :disabled="disabled"
        class="form-control"
        id="dating-wl-ad-account-app-link"
        type="text"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="dating-wl-preland-link">Will You Use a Preland? (If Yes, Please Provide a Link)</label>
    <div class="input-group">
      <input
        v-model="formData.preland_url"
        @change="onChange"
        :disabled="disabled"
        class="form-control"
        id="dating-wl-preland-link"
        type="text"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="dating-wl-app-login">Test Login for This Site or App *</label>
    <div class="input-group">
      <input
        v-model="formData.test_login"
        @change="onChange"
        :disabled="disabled"
        class="form-control"
        id="dating-wl-app-login"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="dating-wl-app-password">Test Password for This Site or App *</label>
    <div class="input-group">
      <input
        v-model="formData.test_password"
        @change="onChange"
        :disabled="disabled"
        class="form-control"
        id="dating-wl-app-password"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="dating-wl-spend">How Much Do You Plan to Spend During Your First 3 Months on Facebook? *</label>
    <div class="input-group">
      <span class="input-group-text">$</span>
      <input
        v-model="formData.plan_to_spend"
        @change="onChange"
        :disabled="disabled"
        class="form-control"
        id="dating-wl-spend"
        required
      />
    </div>
  </div>
</template>
